module.exports = __webpack_public_path__ + "static/og-image-df9ff665d97c8a11713afabe40c57099.jpg";